/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import userModule, { StoreChatUserState } from './user';
import conversationModule, { StoreChatConversationState } from './conversation';

export interface StoreChatState {
  user: StoreChatUserState;
  conversation: StoreChatConversationState;
}

export default {
  namespaced: true,
  modules: {
    user: userModule,
    conversation: conversationModule,
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {},
};
